<template>
  <div class="listbox" role="listbox">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
// No gap between rows: the active row and the hovered one are both filled, and a strip of white
// between two filled rows reads as a divider that is not there
.listbox {
  display: flex;
  flex-direction: column;

  background-color: var(--t-color-neutral-white);
  border-radius: var(--t-border-radius-sm);
  // Rows run edge to edge, so a highlighted first or last row fills its corner instead of stopping short
  overflow: hidden;
  box-shadow: var(--t-shadow-sm);
}
</style>
